const generateLinkedinShareLink = (urlToShare) =>
  `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(urlToShare)}`;

export default generateLinkedinShareLink;
